/* eslint-disable require-jsdoc */

export class SoundSource {
	constructor (context, gainNode, soundUrl, callback) {
		this.context = context;
		this.gainNode = gainNode;
		this.soundUrl = soundUrl;
		this.onload = callback;

		this.bufferList = null;
		this.sound = null;
		this.soundBuf = null;

		this.load();
	}
	loadBuffer (url) {
		// Load buffer asynchronously
		const request = new XMLHttpRequest();
		request.open('GET', url, true);
		request.responseType = 'arraybuffer';

		// eslint-disable-next-line consistent-this
		const loader = this;

		request.onload = function () {
			// Asynchronously decode the audio file data in request.response
			loader.context.decodeAudioData(
				request.response,
				(buffer) => {
					if (!buffer) {
						return;
					}
					loader.bufferList = buffer;
					loader.prepareSound();
					loader.sound = null;
					loader.onload(buffer.duration);
				}
			);
		};

		request.send();
	}
	prepareSound () {
		this.soundBuf = this.context.createBufferSource();
		this.soundBuf.buffer = this.bufferList;
		this.soundBuf.connect(this.gainNode);
	}
	load () {
		this.loadBuffer(this.soundUrl);
	}
	start () {
		// this.stop();
		console.log('start gong');
		this.soundBuf.start(0);
		this.sound = this.soundBuf;

		this.prepareSound();
	}
	stop () {
		const {sound} = this;
		if (sound === null) {
			return;
		}

		if ((sound.playbackState === sound.PLAYING_STATE) || (sound.playbackState === sound.SCHEDULED_STATE)) {
			sound.stop(0);
			this.sound = null;
		}
	}
}
